<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-plus-circle.png" alt="" width="25" height="25" />
      <p class="title-bk">映像視聴ID登録</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: confirmedCreation ? 'school' : 'video-viewing-add' }"> 戻る </router-link>
    </div>
    <div class="container">
      <table class="table">
        <tbody>
          <tr>
            <th scope="row" width="30%" v-if="confirmedCreation">登録が完了しました！</th>
            <th scope="row" width="30%" v-else>以下の内容で登録しますか？</th>
            <td />
          </tr>
          <tr>
            <th scope="row">法人名（法人ID）</th>
            <td>{{ currentCorporationDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">ブランド名（ブランドID）</th>
            <td>{{ currentBrandDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">教場名（教場ID）</th>
            <td>{{ currentSchoolDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">コース名（コースID）</th>
            <td>{{ currentCourseDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">クラス名（クラスID）</th>
            <td>{{ currentTamaiClassDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">利用教材</th>
            <td>{{ currentFiguredProductDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">映像視聴ID名</th>
            <td>{{ currentVideoViewing.nameReading }}</td>
          </tr>
          <template v-if="currentFiguredProductCode == '10'">
            <tr>
              <th scope="row" class="brandname">
                映像視聴ID
                <div class="body-td-explain">（図形の極 + 数の極）</div>
              </th>
              <td>{{ currentVideoViewing.videoPoles[0].uid }}</td>
            </tr>
            <tr v-if="confirmedCreation">
              <th scope="row" class="body-td-red">パスワード（自動生成）</th>
              <td class="body-td-red">{{ currentVideoViewing.videoPoles[0].password }}</td>
            </tr>
            <tr>
              <th scope="row" class="brandname">
                映像視聴ID
                <div class="body-td-explain">（中学生の図形の極 + 中学生の代数の極）</div>
              </th>
              <td>{{ currentVideoViewing.videoPoles[1].uid }}</td>
            </tr>
            <tr v-if="confirmedCreation">
              <th scope="row" class="body-td-red">パスワード（自動生成）</th>
              <td class="body-td-red">{{ currentVideoViewing.videoPoles[1].password }}</td>
            </tr>
          </template>
          <template v-else-if="currentFiguredProductCode == '40'">
            <tr>
              <th scope="row" class="brandname">
                映像視聴ID
                <div class="body-td-explain">（魔法の国語 Grade1）</div>
              </th>
              <td>{{ currentVideoViewing.videoPoles[0].uid }}</td>
            </tr>
            <tr v-if="confirmedCreation">
              <th scope="row" class="body-td-red">パスワード（自動生成）</th>
              <td class="body-td-red">{{ currentVideoViewing.videoPoles[0].password }}</td>
            </tr>
            <tr>
              <th scope="row" class="brandname">
                映像視聴ID
                <div class="body-td-explain">（魔法の国語 Grade2）</div>
              </th>
              <td>{{ currentVideoViewing.videoPoles[1].uid }}</td>
            </tr>
            <tr v-if="confirmedCreation">
              <th scope="row" class="body-td-red">パスワード（自動生成）</th>
              <td class="body-td-red">{{ currentVideoViewing.videoPoles[1].password }}</td>
            </tr>
            <tr>
              <th scope="row" class="brandname">
                映像視聴ID
                <div class="body-td-explain">（魔法の国語 Grade3）</div>
              </th>
              <td>{{ currentVideoViewing.videoPoles[2].uid }}</td>
            </tr>
            <tr v-if="confirmedCreation">
              <th scope="row" class="body-td-red">パスワード（自動生成）</th>
              <td class="body-td-red">{{ currentVideoViewing.videoPoles[2].password }}</td>
            </tr>
            <tr>
              <th scope="row" class="brandname">
                映像視聴ID
                <div class="body-td-explain">（魔法の国語 Grade4）</div>
              </th>
              <td>{{ currentVideoViewing.videoPoles[3].uid }}</td>
            </tr>
            <tr v-if="confirmedCreation">
              <th scope="row" class="body-td-red">パスワード（自動生成）</th>
              <td class="body-td-red">{{ currentVideoViewing.videoPoles[3].password }}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <th scope="row" class="brandname">
                映像視聴ID
              </th>
              <td>{{ currentVideoViewing.videoPoles[0].uid }}</td>
            </tr>
            <tr v-if="confirmedCreation">
              <th scope="row" class="body-td-red">パスワード（自動生成）</th>
              <td class="body-td-red">{{ currentVideoViewing.videoPoles[0].password }}</td>
            </tr>
          </template>
          <tr v-if="confirmedCreation">
            <td class="body-td-red" colspan="3">
              <br />
              <br />
              ※パスワードはこの画面から移動すると暗号化されるため、再表示できません。ご注意ください。
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-center">
        <template v-if="!confirmedCreation">
          <button type="button" class="btn-confirm" @click="confirmRevised">修正</button>
          <button type="button" class="btn-red" @click="confirmSaved" :disabled="isLoading">登録</button>
        </template>
        <template v-else>
          <button type="button" class="btn-confirm" @click="confirmPassword">一覧に戻る</button>
        </template>
        <b-alert variant="danger" v-show="errorMessage" dismissible show>{{ errorMessage }}</b-alert>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import store from '@/store/index.js';
import {
  basicCorporationNameIdPresent,
  basicBrandNameIdPresent,
  basicSchoolNameIdPresent,
  basicCourseNameIdPresent,
  basicTamaiClassNameIdPresent,
} from '@/presenters/fields';
import isEmpty from 'lodash/isEmpty';

export default {
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
  },
  data() {
    return {
      confirmedCreation: false,
      errorMessage: null,
      isLoading: false,
      currentFiguredProductDisplay: '',
      currentFiguredProductCode: '',
    };
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (store.getters['video_viewing/existsRegistrationRequiredParams']) {
      next();
    } else {
      next({ name: 'video-viewing-add' });
    }
  },
  mounted() {
    this.setCurrentFiguredProduct();
  },
  computed: {
    currentVideoViewing() {
      if (this.video_viewing.editingVideoViewing) {
        return this.video_viewing.editingVideoViewing;
      } else {
        return this.video_viewing.videoViewing;
      }
    },
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.currentVideoViewing.corporation);
    },
    currentBrandDisplay() {
      return basicBrandNameIdPresent(this.currentVideoViewing.brand);
    },
    currentSchoolDisplay() {
      return basicSchoolNameIdPresent(this.currentVideoViewing.school);
    },
    currentCourseDisplay() {
      return basicCourseNameIdPresent(this.currentVideoViewing.course);
    },
    currentTamaiClassDisplay() {
      return basicTamaiClassNameIdPresent(this.currentVideoViewing.tamaiClass);
    },
    ...mapState(['video_viewing']),
  },
  methods: {
    setCurrentFiguredProduct() {
      if (isEmpty(this.currentVideoViewing)) return;
      const schoolProducts = this.currentVideoViewing.school.figuredProducts;
      const selectedProduct = schoolProducts.find((product) => {
        return product.code === this.currentVideoViewing.figuredProduct;
      });
      this.currentFiguredProductDisplay = selectedProduct.name;
      this.currentFiguredProductCode = this.currentVideoViewing.figuredProduct;
    },
    confirmRevised() {
      // This path is for Adding new Video Viewing flow
      this.$logger.debug('Need revise, go back');
      this.$router.push({ name: 'video-viewing-add' });
    },
    confirmSaved() {
      this.isLoading = true;
      this.$logger.debug('Finished Editing: ' + JSON.stringify(this.currentVideoViewing));
      // This path is for Adding new Video Viewing flow
      this.finishEditingVideoViewing().then(
        (response) => {
          this.$logger.debug('Show Password ' + response);
          this.confirmedCreation = true;
        },
        (error) => {
          this.isLoading = false;
          this.errorMessage = error;
          this.$logger.debug('Error ' + error);
        }
      );
    },
    confirmPassword() {
      this.$logger.debug('Password seen and saved');
      this.$router.push({ name: 'school' });
    },
    ...mapActions('video_viewing', ['finishEditingVideoViewing']),
  },
};
</script>

<style scoped>
.btn-confirm {
  margin-left: 0px;
}
.body-td-explain {
  margin-left: 5px;
  font-size: 10px;
}
.body-td-red {
  color: red;
}
</style>
